export default __webpack_public_path__ + "static/Grafana_Istio_Dashboard-8a09b786fdb6bc944f193950ca70e6cb.webp";